<script setup lang="ts">
/** 色值字段：色块 + 文本 + 原生取色器 + 「无」 */
import { computed } from 'vue';

const props = defineProps<{ value: string | null; allowNone?: boolean }>();
const emit = defineEmits<{ change: [value: string | null] }>();

const isNone = computed(() => !props.value || props.value === 'none');
const hex = computed(() =>
  props.value && /^#[0-9a-f]{6}$/i.test(props.value) ? props.value : '#000000',
);
</script>

<template>
  <div class="field">
    <span class="swatch" :class="{ 'is-none': isNone }" :style="isNone ? {} : { background: value ?? '' }" />
    <div class="input">
      <input :value="props.value ?? 'none'" spellcheck="false" @change="emit('change', ($event.target as HTMLInputElement).value.trim() || null)" />
    </div>
    <input
      class="color-input"
      type="color"
      :value="hex"
      title="取色"
      @input="emit('change', ($event.target as HTMLInputElement).value)"
    />
    <button v-if="props.allowNone" class="ghost-btn" title="设为无" @click="emit('change', null)">无</button>
  </div>
</template>
